import serverInit from "@/plugins/init/server"
import clientInit from "@/plugins/init/client"

/**
 * 初始化数据
 * @param {*} context
 * @returns
 */
export const bootstrapData = async ({ store, req }) => {
  return await store.dispatch("bootstrapData", { req })
}

//  通过 Nuxt.js 的插件系统 自动执行
//  服务端（SSR）：在服务器端渲染时，插件会在 每个请求 之前执行（process.server 为 true）。
//  客户端（CSR）：在浏览器端渲染时，插件会在 应用挂载 之前执行（process.client 为 true）。
export default async function (context, inject) {
  const { $cookies, store } = context
  // 若cookie中LOGIN_FLAG为true时，走服务端初始化逻辑，否则走客户端初始化逻辑
  // 读取后端区分网站的配置, 动态的load  css
  if (process.server) {
    await serverInit(context)
    const LOGIN_FLAG = $cookies.get("LOGIN_FLAG")
    if (LOGIN_FLAG) {
      await bootstrapData(context)
    }
    $cookies.remove("LOGIN_FLAG")
  } else {
    clientInit(context)
    const { isServerInit } = store.state
    const commonParams = isServerInit ? await store.dispatch("getCommonParamsSet") : await bootstrapData(context)
    if (isServerInit) {
      // 设置本地存储数据
      await store.dispatch("setStorageData")
    }
    if (commonParams) {
      inject("commonParams", commonParams)
    }
  }
  $cookies.remove("LOGIN_FLAG")
}
